import { Button } from "react-bootstrap";
import { Container, Form, Navbar } from "react-bootstrap";

const NavBar = ({ search }) => {
  const searchFunc = (word) => {
    search(word);
  };
  return (
    <Navbar className="bg-dark" expand="lg" variant="dark">
      <Container>
        <Navbar.Brand href="#" className="header-nav">
          مطعم جديد
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll" className="justify-content-md-end">
          <Form
            className="d-flex gap-2 mt-4 mt-lg-0"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <Form.Control
              type="بحث"
              placeholder="Search"
              className="me-2"
              aria-label="Search"
              onChange={(e) => {
                searchFunc(e.target.value);
              }}
            />
            <Button className="bg-white text-black cursor-poitner">بحث</Button>
          </Form>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
